'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _get2 = require('babel-runtime/helpers/get');
var _get3 = _interopRequireDefault(_get2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (D3Chart) {
  return function (_Component) {
    (0, _inherits3.default)(ReactChart, _Component);
    function ReactChart(props) {
      (0, _classCallCheck3.default)(this, ReactChart);

      // shouldComponentUpdate is useful to determine isDirty
      // but can't be used alone since we still want to update meta
      var _this = (0, _possibleConstructorReturn3.default)(this, (ReactChart.__proto__ || (0, _getPrototypeOf2.default)(ReactChart)).call(this, props));
      _this.needD3Update = true;
      _this.chart = null;
      return _this;
    }
    (0, _createClass3.default)(ReactChart, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        (0, _get3.default)(ReactChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReactChart.prototype), 'componentDidMount', this) && (0, _get3.default)(ReactChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReactChart.prototype), 'componentDidMount', this).call(this);
        if (!this.needD3Update) return;
        this.chart = new D3Chart(this.refs.chart, this.props.options, this.props.data, this.props.getInitialOptions, this.props.getAxisOptions);
        this.needD3Update = false;

        /*if (isFunction(this.props.getInitialOptions)) {
          this.props.getInitialOptions(cloneDeep(this.chart.options));
        }*/
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        (0, _get3.default)(ReactChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReactChart.prototype), 'componentDidUpdate', this) && (0, _get3.default)(ReactChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReactChart.prototype), 'componentDidUpdate', this).call(this);
        if (!this.needD3Update) return;
        this.chart && this.chart.update && this.chart.update(this.refs.chart, this.props.options, this.props.data, this.props.getInitialOptions, this.props.getAxisOptions);
        this.needD3Update = false;
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        (0, _get3.default)(ReactChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReactChart.prototype), 'componentWillUnmount', this) && (0, _get3.default)(ReactChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReactChart.prototype), 'componentWillUnmount', this).call(this);
        this.chart && this.chart.destroy && this.chart.destroy(this.refs.chart);
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        (0, _get3.default)(ReactChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReactChart.prototype), 'shouldComponentUpdate', this) && (0, _get3.default)(ReactChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReactChart.prototype), 'shouldComponentUpdate', this).call(this, nextProps);
        this.needD3Update = this.props.data !== nextProps.data || this.props.options !== nextProps.options;
        return true;
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement('div', {
          ref: 'chart'
        });
      }
    }]);
    return ReactChart;
  }(_react.Component);
};